module.exports = __webpack_public_path__ + "static/media/iconComandos.d1781d8d.png";